import { ArrowBack } from '@mui/icons-material';
import { Divider, Step, StepLabel, Stepper } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { paths } from 'src/paths';
import {
  resetSaveMiscDocumentAction,
  saveMiscDocumentAction,
} from 'src/redux/actions/documentationAction';
import { getSinglePatient } from 'src/redux/actions/patientAction';
import PhysicianDocTable from './physician-doc-table';
import PreviewSignatureDocument from './preview-signature-document';
import UploadPhysicianDoc from './upload-physician-doc';
import AttachmentType from './Attachment-type';

const PhysicianSignDocument = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { patients, patientDetails, episodeOfCare, details } = paths;
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const getAllSubmittedDocumentResponse = useSelector(
    (state: any) => state.getAllSubmittedDocumentReducer
  );

  useEffect(() => {
    dispatch(
      getSinglePatient({
        patientId: getPatientId,
      })
    );
  }, [getPatientId]);
  const steps = ['Attachment Type', 'Select Clinical Document', 'Upload attachment', 'PREVIEW'];
  const [activeStep, setActiveStep] = useState(0);

  const [physicianSignatureDoc, setPhysicianSignatureDoc] = useState<any>([]);
  const [supervisorSignatureDoc, setSupervisorSignatureDoc] = useState<any>([]);
  const signDocumentType = [
    'EVALUATION_PT',
    'EVALUATION_REFORM',
    "EVALUATION_REFORM_PT",
    "EVALUATION_REFORM_OT",
    "EVALUATION_REFORM_SLP",
    'EVALUATION_OT',
    'EVALUATION_SLP',
    'RECERTIFICATION_OT',
    'RECERTIFICATION_SLP',
    'RECERTIFICATION_PT',
    'RECERTIFICATION_REFORM_OT',
    'RECERTIFICATION_REFORM_SLP',
    'RECERTIFICATION_REFORM_PT',
    'TRANSITIONAL_EVALUATION_SLP',
    'TRANSITIONAL_EVALUATION_PT',
    'TRANSITIONAL_EVALUATION_OT',
  ];

  const sortByDateOfServiceAndGroup = (completedDocs: any) => {
    const groupedDocuments = completedDocs?.reduce((groups: any, document: any) => {
      const { formType } = document;
      if (!groups[formType]) {
        groups[formType] = [];
      }
      groups[formType].push(document);
      return groups;
    }, {});

    const sortedDocuments = Object?.values(groupedDocuments)?.flatMap(
      (group: any) =>
        group?.sort(
          (a: any, b: any) =>
            Number(new Date(a?.dateOfService)) - Number(new Date(b?.dateOfService))
        )
    );
    return sortedDocuments;
  };

  useEffect(() => {
    try {
      const completedDocs: any = [];
      const supervisorSignature: any = [];
      getAllSubmittedDocumentResponse?.response?.content?.length &&
        getAllSubmittedDocumentResponse?.response?.content?.map((document: any) => {
          if (
            document?.status === 'COMPLETED' &&
            document?.supervisorStatus === 'PENDING' &&
            signDocumentType?.includes(document?.formType)
          ) {
            completedDocs.push(document);
          } else if (
            document?.supervisorStatus === 'PENDING' &&
            !signDocumentType?.includes(document?.formType)
          ) {
            supervisorSignature.push(document);
          }
        });

      setPhysicianSignatureDoc(sortByDateOfServiceAndGroup(completedDocs));
      setSupervisorSignatureDoc(sortByDateOfServiceAndGroup(supervisorSignature));
    } catch (error) {
      console.error('error', error);
    }
  }, [getAllSubmittedDocumentResponse]);

  const handleNext = () => {
    if (isLastStep()) {
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isLastStep = () => {
    return activeStep === steps.length - 1;
  };

  const handleNextSelectPhysician = () => {
    setUploadedDoc({});
    handleNext();
  };

  const [uploadedDoc, setUploadedDoc] = useState<any>({});
  const [selectedDocument, setSelectedDocument] = useState<any>('');
  const [selectedAttachmentType, setSelectedAttachmentType] = useState('');
  const [otherType, setOtherType] = useState('');
  const getTherapistProfileData = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );
  const saveMiscDocResponse = useSelector((state: any) => state.saveMiscellaneousDocumentsReducer);

  const handleUploadSignFile = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      let formData = new FormData();
      formData.append('file', uploadedDoc);
      formData.append('therapistId', getTherapistProfileData?.providerId);
      formData.append('episodeOfCareId', location?.state?.episodeOfCareId);
      formData.append('documentName', uploadedDoc?.name);
      if (selectedAttachmentType === 'PhysicianSignature') {
        dispatch(
          saveMiscDocumentAction({
            data: formData,
            param: {
              type: 'PHYSICIAN_SIGNATURE',
              uuid: selectedDocument?.uuid,
            },
          })
        );
      } else if (selectedAttachmentType === 'SUPERVISOR_SIGNATURE') {
        dispatch(
          saveMiscDocumentAction({
            data: formData,
            param: {
              type: 'SUPERVISOR_SIGNATURE',
              uuid: selectedDocument?.uuid,
            },
          })
        );
      } else {
        dispatch(
          saveMiscDocumentAction({
            data: formData,
            param: {
              type: !!otherType ? otherType : 'OTHER',
            },
          })
        );
      }
    };
    reader.readAsDataURL(uploadedDoc);
  };

  const handleSelectedAttachmentType = () => {
    setSelectedDocument('');
    handleNext();
  };

  const renderComponent = (stepIndex: any) => {
    switch (stepIndex) {
      case 0:
        return (
          <AttachmentType
            activeStep={activeStep}
            handleSelectedAttachmentType={handleSelectedAttachmentType}
            handleBack={handleBack}
            handelNavigateBack={handelNavigateBack}
            selectedAttachmentType={selectedAttachmentType}
            setSelectedAttachmentType={setSelectedAttachmentType}
            setOtherType={setOtherType}
            otherType={otherType}
          />
        );
      case 1:
        return (
          <PhysicianDocTable
            activeStep={activeStep}
            physicianSignatureDoc={
              selectedAttachmentType === 'PhysicianSignature'
                ? physicianSignatureDoc
                : selectedAttachmentType === 'SUPERVISOR_SIGNATURE'
                ? supervisorSignatureDoc
                : []
            }
            handleNextSelectPhysician={handleNextSelectPhysician}
            handleBack={handleBack}
            setSelectedDocument={setSelectedDocument}
            selectedDocument={selectedDocument}
            handelNavigateBack={handelNavigateBack}
            selectedAttachmentType={selectedAttachmentType}
          />
        );
      case 2:
        return (
          <UploadPhysicianDoc
            activeStep={activeStep}
            setUploadedDoc={setUploadedDoc}
            handleBack={handleBack}
            handleNext={handleNext}
            uploadedDoc={uploadedDoc}
            handelNavigateBack={handelNavigateBack}
          />
        );
      case 3:
        return (
          <PreviewSignatureDocument
            activeStep={activeStep}
            handleUploadSignFile={handleUploadSignFile}
            handleBack={handleBack}
            uploadedDoc={uploadedDoc}
            handelNavigateBack={handelNavigateBack}
          />
        );

      default:
        return null;
    }
  };

  const handelNavigateBack = () => {
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: location?.state?.episodeOfCareId,
        getPatientId,
      },
    });
  };
  useEffect(() => {
    if (!saveMiscDocResponse.isDocumentSave && saveMiscDocResponse.response === null) return;
    handelNavigateBack();
    dispatch(resetSaveMiscDocumentAction());
  }, [saveMiscDocResponse]);

  return (
    <>
      <Seo title="Dashboard: Customer Details" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
          height: '100%',
        }}
      >
        <Container
          sx={{ height: '100%' }}
          maxWidth="xl"
        >
          <Stack
            sx={{ height: '100%' }}
            spacing={3}
          >
            <Stack spacing={4}>
              <div>
                <Link
                  color="text.primary"
                  component={RouterLink}
                  sx={{
                    alignItems: 'center',
                    display: 'inline-flex',
                  }}
                  href={`${patients}/${patientDetails}${episodeOfCare}${details}`}
                  state={{
                    episodeOfCareId: location?.state?.episodeOfCareId,
                    getPatientId,
                  }}
                  // onClick={handelNavigateBack}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowBack sx={{ color: '#6C737F' }} />
                  </SvgIcon>
                  <Typography variant="subtitle1">
                    Back to Episode of Care Details -
                    {` ${patientData?.lastName ?? ''} ${patientData?.firstName ?? ''}`}
                  </Typography>
                </Link>
              </div>
              <Stack
                alignItems="center"
                direction="row"
                spacing={2}
              >
                <Stack
                  spacing={1}
                  pl={1}
                >
                  <Typography variant="h4">Attach New Document </Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack
              width={'100%'}
              sx={{ height: '100%' }}
              flexDirection={'row'}
              mt={5}
            >
              <Box
                // mt={5}
                width={'20%'}
                // sx={{ border: '1px solid orange' }}
              >
                <Stepper
                  orientation="vertical"
                  activeStep={activeStep}
                >
                  {steps.map((label: any, index) => {
                    const labelProps: {
                      optional?: React.ReactNode;
                      error?: boolean;
                    } = {};

                    return (
                      <Step key={label}>
                        <StepLabel {...labelProps}>
                          <Typography variant="overline">{label}</Typography>
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
              <Divider orientation="vertical" />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  // border: '1px solid red',
                  // mt: 2,
                  height: '100%',
                }}
                width={'80%'}
                // mt={5}
              >
                {renderComponent(activeStep)}
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default PhysicianSignDocument;
